interface envConfig {
  AUTH_API?: string;
  POFFICE_API?: string;
  PDISCHRAGES_API?: string;
  PROJECT_API?: string;
  WASTE_API?: string;
  COLLECTION_AREA_API?: string;
  [propName: string]: unknown;
}

declare global {
  interface Window {
    ENV_CONFIG: envConfig & { ENV: 'dev' | 'tst' | 'prod' };
  }
}

// 代理转发请求
let exports: envConfig = {
  AUTH_API: '/authApi',
  POFFICE_API: '/poffice',
  PDISCHRAGES_API: '/pdischarges',
  PROJECT_API: '/project',
  WASTE_API: '/waste',
  COLLECTION_AREA_API: '/collection-area'
};

try {
  // 因为 vite.config.js 引用此文件且运行处于 node 没有 window 会报错
  if (window && window.ENV_CONFIG) exports = { ...exports, ...window.ENV_CONFIG };
} catch (error) {
  // console.log('🚀 ~ error', error);
}

export const {
  ENV,
  AUTH_API,
  POFFICE_API,
  PDISCHRAGES_API,
  PROJECT_API,
  WASTE_API,
  COLLECTION_AREA_API
} = exports;
// eslint-disable-next-line
console.log('🚀 ~ exports', exports);
